import { FieldValues } from 'react-hook-form/dist/types/fields';
import { FieldName } from 'react-hook-form/dist/index.ie11';
import { UseFormMethods } from 'react-hook-form/dist/types';
import { useEffect } from 'react';

type UseCookbookCheckboxSelectionProps<
  TFieldValues extends FieldValues = FieldValues
> = {
  selectAllKey: FieldName<TFieldValues>;
  selectedItemsKey: FieldName<TFieldValues>;
  selectableItemsKey: FieldName<TFieldValues>;
  formMethods: Pick<UseFormMethods<FieldValues>, 'watch' | 'setValue'>;
};

type UseCookbookCheckboxSelectionReturn = { indeterminate: boolean };

// TODO: Move this hook in a common place and reuse it in AdminGroupsToLocModal.tsx, since
//  this function implements exactly the same functionality which can be found in that component.
//  src/components/selfService/features/LineOfCredit/details/Groups/AddGroupsToLocModal.tsx
//  A ticket was created for this change: https://jira.grubhub.com/browse/CFE-843
export function useCookbookSelectAllCheckbox<
  TFieldValues extends FieldValues = FieldValues
>({
  selectAllKey,
  selectedItemsKey,
  selectableItemsKey,
  formMethods: { watch, setValue },
}: UseCookbookCheckboxSelectionProps<TFieldValues>): UseCookbookCheckboxSelectionReturn {
  const selectedItems = watch(selectedItemsKey);
  const selectableItems = watch(selectableItemsKey);
  const selectAll = watch(selectAllKey);

  const indeterminate =
    selectedItems.length > 0 && selectedItems.length !== selectableItems.length;

  useEffect(() => {
    setValue(selectAllKey, !!selectedItems.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems.length, selectAllKey]);

  useEffect(() => {
    if (selectAll) {
      if (!indeterminate) {
        setValue(selectedItemsKey, selectableItems);
      }
    } else {
      setValue(selectedItemsKey, []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectAll, selectedItemsKey]);

  return {
    indeterminate,
  };
}
